import { render, staticRenderFns } from "./apply-post.vue?vue&type=template&id=85f01f16&scoped=true&"
import script from "./apply-post.vue?vue&type=script&lang=js&"
export * from "./apply-post.vue?vue&type=script&lang=js&"
import style0 from "./apply-post.vue?vue&type=style&index=0&id=85f01f16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f01f16",
  null
  
)

export default component.exports